import { useMutation } from "@apollo/client/react";
import { UnscheduleDowntimeBlock } from "./downtimeBlock.gql";
import { removeDowntimeBlock } from "./helpers/handleUpdateDowntimeBlocks";

export default function useUnscheduleDowntimeBlock() {
  const [unscheduleDowntimeBlock] = useMutation(UnscheduleDowntimeBlock);

  return ({ id }) =>
    unscheduleDowntimeBlock({
      update: (proxy) => {
        removeDowntimeBlock(id, proxy);
      },
      variables: {
        id,
      },
    });
}
